import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

import { File } from '@core/objects/file';
import { AnnotationsCounter } from '@core/objects/annotations';
import { FilesListItemMenuClick } from '../files-list-item-menu-click';
import * as flContexts from '@core/constants/files-list-contexts.constants';


/**
 * component for list of files in sections which display notes counter.
 */
@Component({
    selector: 'core-files-list-notes',
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.scss']
})
export class FilesListNotesComponent implements OnInit, OnChanges {
    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;

    // GRID MANAGEMENT: 
    // Initial number of items to load at once
    public readonly GRID_ITEMS_PER_PAGE = 12;

    public readonly FILES_VIEW_MODE_LIST = 'list';
    public readonly FILES_VIEW_MODE_GRID = 'grid';

    @Input() files: Array<File>;
    // this is the selected file in the list for preview coming from parent, only used to UNSET fileselected.
    @Input() file: File; 
    @Input() context: string = flContexts.CTX.DEFAULT; 
    // may-2023: notes will become the notes counter
    @Input() notes: Array<AnnotationsCounter>;
    @Input() menu: Array<ThreeDotsMenuItem> = [];
    
    @Output() actionClick= new EventEmitter<File>();
    @Output() menuClick = new EventEmitter<FilesListItemMenuClick>();
    @Output() iconDownloadClick = new EventEmitter<File>();

    public status: number = this.STATUS_LOADING;
    public completeMenu:  Array<ThreeDotsMenuItem> = [];
    public menuWithComments:  Array<ThreeDotsMenuItem> = [];
    public menuWithSignatures:  Array<ThreeDotsMenuItem> = [];
    public viewMode: string = this.FILES_VIEW_MODE_LIST;

    public displayedFiles: Array<File> = [];
    public fileSelected: File = null;
    
    // CAREFUL: click management has to be controlled in parent component by key 
    // or trigger here for all components a notification to download. But here we dont have prefixUrl and/or context
    public itemMenuWithComments: ThreeDotsMenuItem = {
        title: "Download with comments",
        key: "download-comments",
        icon: "download_comments",
        order: 5
    };

    public itemMenuPdfWithSignatures: ThreeDotsMenuItem = {
        title: "Download with signatures",
        key: "download-signatures",
        icon: "download_comments",
        order: 6
    };

    ngOnInit(): void {
        this.setMenus();
        this.initGridItems();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.notes && changes.notes.currentValue){
            this.status = this.STATUS_DONE;
        }
        // add download wiht comments when context is default by now, if it message we don't allow. 25/09/2023 <diego@twonas.com>
        // if(changes.menu && this.menuExtended.length == 0 && this.context == 'default'){
        //     // this.updateExtendedMenu( this.menuPdfWithComments);
        // }
        if(changes.file && this.file == null){
            // set/unset current selected file to null to quit highlighted 'on-preview' class on the list item <diego@twonas.com>
            this.fileSelected = null; 
        }
    }

    public getNotes(file: File){
        return this.notes.filter((n: AnnotationsCounter) => n.file.id == file.id)[0]?.annotations?.count;
    }

    // here we select the menu we have to display depending on context
    public getItemFileMenu(file: File): Array<ThreeDotsMenuItem> {
        switch (this.context) {
            case flContexts.CTX.DEFAULT :
                // ctx default with notes
                if(this.getNotes(file) > 0)  
                    return this.menuWithComments;
                return this.menu;
            case flContexts.CTX.APP_ARTWORK_DETAILS_FEEDBACK :
            case flContexts.CTX.SHARE_ARTWORK_DETAILS_FEEDBACK :
                if(this.getNotes(file) > 0 && file.extension.toLowerCase() == 'pdf')  
                    return this.completeMenu;
                if(file.extension.toLowerCase() == 'pdf')
                    return this.menuWithSignatures;
                if(this.getNotes(file) > 0)  
                    return this.menuWithComments;
                return this.menu;
            case flContexts.CTX.APP_ARTWORK_DETAILS :
                // ctx app artwork_details with notes
                if(this.getNotes(file) > 0)  
                    return this.menuWithComments;
                return this.menu;
            default:
                return this.menu;
        }
    }

    public changeView(mode: string) : void {
        this.viewMode = mode;
        if(mode == this.FILES_VIEW_MODE_GRID){
            this.initGridItems();
        }
    }

    public showMoreGridItems() :void {
        const startIndex = this.displayedFiles.length;
        const endIndex = startIndex + this.GRID_ITEMS_PER_PAGE;
        this.displayedFiles.push(...this.files.slice(startIndex, endIndex));
     
    }

    public openPreview(file: File) : void {
        this.fileSelected = (this.fileSelected?.id == file.id) ? null : file;
        this.actionClick.emit(file);

    }

    public onMenuClick(fileItem: FilesListItemMenuClick) : void {
        // set selected file when menu notes clicked as well to highlight the file item htat is on the preview.
        if(fileItem.key == 'notes'){
            this.fileSelected = (this.fileSelected?.id == fileItem.file.id) ? null : fileItem.file;
        }
        this.menuClick.emit(fileItem);
    }

    protected initGridItems() : void {
        this.displayedFiles = this.files.slice(0, this.GRID_ITEMS_PER_PAGE);
    }

    protected setMenus() {
        this.completeMenu = [...this.menu, this.itemMenuWithComments,this.itemMenuPdfWithSignatures];
        // this.completeMenu.push(this.itemMenuWithComments);
        // this.completeMenu.push(this.itemMenuPdfWithSignatures);

        this.menuWithComments = [...this.menu, this.itemMenuWithComments];
        // this.menuWithComments.push(this.itemMenuWithComments);

        this.menuWithSignatures = [...this.menu,this.itemMenuPdfWithSignatures];
        // this.menuWithSignatures.push(this.itemMenuPdfWithSignatures);
    }
}
